import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-secondary-100/80 text-secondary-700 text-xs font-semibold rounded-full mb-3">
            热门话题
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            话题热度榜
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            当下观众讨论最热烈的影视话题，点击探索相关内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
          {topicsData.map((topic, i) => (
            <div
              key={i}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-full hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                #{topic.tag}
              </span>
              <span className="text-xs font-medium text-primary-500 bg-primary-100/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.hot >= 500
                  ? `${(topic.hot / 10000).toFixed(0)}万`
                  : topic.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}